
  <div class="align-center scaffold-image-holder">
    <div class="image-controls-holder">
      <div class="image-block-title" *ngIf="item.image_title">
        <div>{{item.image_title}}</div>
      </div>
      <div class="image-block-buttons" *ngIf="item.allow_file_select">
        <button nbButton ghost status="info" (click)="clearFile()" [disabled]="checkDisable()">{{item.clear_label || 'remove_image'| translation}}</button>
      </div>
    </div>

      <img [style.height]="item.height +'px' || 'unset'" *ngIf="item.file|| (item.url && item.url.length > 0 )" [style.width]="item.width +'px' || 'unset'" [alt]='item?.translation_key||item?.text| translation|translationFromString | transformText :item?.text_transform' [src]="src|safe" (click)="selectFile(item, 'file', 'image')">
      <img [style.height]="item.height +'px' || 'unset'" alt='Default image' *ngIf="!item.file && (!item.url || item.url.length == 0)" src="https://s3.us-east-2.amazonaws.com/k16-hosted-lib/default.jpg">

  </div>

